import { useState, useEffect } from 'react';

interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  userAgent: string;
  screenWidth: number;
  screenHeight: number;
  deviceType: 'mobile' | 'tablet' | 'desktop';
}

const useDeviceDetection = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    userAgent: '',
    screenWidth: 0,
    screenHeight: 0,
    deviceType: 'desktop',
  });

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent;
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      // User agent based detection
      const mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const tabletRegex = /iPad|Android(?=.*\bMobile\b)(?=.*\bSafari\b)/i;

      const isMobileByUserAgent = mobileRegex.test(userAgent);
      const isTabletByUserAgent = tabletRegex.test(userAgent);

      // Screen size based detection
      const isMobileByScreen = screenWidth <= 768;
      const isTabletByScreen = screenWidth > 768 && screenWidth <= 1024;

      // Combined detection
      const isMobile = isMobileByUserAgent || isMobileByScreen;
      const isTablet = isTabletByUserAgent || isTabletByScreen;
      const isDesktop = !isMobile && !isTablet && screenWidth > 1024;

      // Determine device type
      let deviceType: 'mobile' | 'tablet' | 'desktop' = 'desktop';
      if (isMobile) deviceType = 'mobile';
      else if (isTablet) deviceType = 'tablet';

      setDeviceInfo({
        isMobile,
        isTablet,
        isDesktop,
        userAgent,
        screenWidth,
        screenHeight,
        deviceType,
      });
    };

    // Initial detection
    detectDevice();

    // Listen for window resize
    window.addEventListener('resize', detectDevice);

    return () => {
      window.removeEventListener('resize', detectDevice);
    };
  }, []);

  return deviceInfo;
};

export default useDeviceDetection;
